import React, { useState, useEffect, useId } from "react";
import { styled, createTheme, ThemeProvider } from "@mui/material/styles";
import {
  useMatch,
  useResolvedPath,
  Link,
  Outlet,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Button, Tooltip,Divider } from "@mui/material";
//import logo from "../assets/images/quanti-logo-white.png";
//import logo from "../assets/images/sims.svg";
import logo from "../assets/images/sims.png";
import takedaLogo from "../assets/images/takeda-logo.png";
import useAuth from "../hooks/useAuth";
import useSelectedCountry from "../hooks/useSelectedCountry";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";

//Sidebar Icons
import GridViewSharpIcon from "@mui/icons-material/GridViewSharp";
import TuneIcon from "@mui/icons-material/Tune";
import MultilineChartIcon from "@mui/icons-material/MultilineChart";
import ExploreIcon from "@mui/icons-material/Explore";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ExitToAppTwoToneIcon from "@mui/icons-material/ExitToAppTwoTone";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch } from "react-redux";
import { setState } from "../store/loginSlice";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import LogoutIcon from '@mui/icons-material/Logout';
import useIdleTimeout from "../hooks/userIdleTimeout";
import useTokenValidation from "../hooks/useTokenValidation";

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
} from "@mui/material";



const drawerWidth = 200;
const closedDrawerWidth = 60;
const primaryBackground="#333333";
const white = "#FFFFFF";
const blackish = "#303030";
const montserratFont = "Montserrat, sans-serif";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${drawerWidth}px`,
    }),
    ...(!open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${closedDrawerWidth}px`,
    }),
    ...(!open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: `${closedDrawerWidth}px`,
    }),
  })
);

const appBarTheme = createTheme({
  palette: {
    primary: {
      main: "#fff",
    },
    darkred:{
			main: "#891515",
			light: "#AD2A1C",
		}
  },
});

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  transition: theme.transitions.create(["margin", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  ...(!open && {
    width: `calc(100% - ${closedDrawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  padding: theme.spacing(0, 0),
  justifyContent: "space-between",
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const openedDrawer = (theme) => ({
  width: drawerWidth,
  background: primaryBackground,
  color: white,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedDrawer = (theme) => ({
  background: primaryBackground,
  color: white,
  width: closedDrawerWidth,
  maxWidth: closedDrawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  background: primaryBackground,
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedDrawer(theme),
    "& .MuiDrawer-paper": openedDrawer(theme),
  }),
  ...(!open && {
    ...closedDrawer(theme),
    "& .MuiDrawer-paper": closedDrawer(theme),
  }),
}));

export default function MainLayout() {
  const xyz = useAuth();
  const [open, setOpen] = useState(false);
  const [country, setCountry] = useState("");
  // const { id } = useParams();
  const countries = xyz?.auth?.userCountries;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedIndex, setSelectedIndex] = React.useState(0);

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  const userFirstName = data.firstName;
  const userLastName = data.lastName;
  const userEmail = data.email;
  const countriesList = data.userCountries;
  const isAdmin = data.isAdmin;
  const isRestricted=data.restrictedAccess;
  const { selectedCountry, setSelectedCountry } = useSelectedCountry();
  const [selectedCountryData, setSelectedCountryData ] = useState("Select");
  const menuSelection = {
    dashboard: 0,
    setup: 1,
    analyze: 2,
    define: 3,
    approval: 4,
    filetransfer: 5,
    review: 6,
    functionaladmin: 7,
    admin: 8,
  };

  /* Navigation links */
  const navigationTop = [
    {
      label: "Dashboard",
      route: "/dashboard",
      icon: <GridViewSharpIcon sx={{ color: white }} />,
    },
    ...(isRestricted==0
      ? [{
      label: "Setup",
      route: "/setup",
      icon: <TuneIcon sx={{ color: white }} />,
    },]
      : []),
    {
      label: "Analyze",
      route: "/analyze",
      icon: <MultilineChartIcon sx={{ color: white }} />,
    },
    {
      label: "Define",
      route: "/define",
      icon: <ExploreIcon sx={{ color: white }} />,
    },
    {
      label: "Approval",
      route: "/approval",
      icon: <AssignmentTurnedInIcon sx={{ color: white }} />,
    },
    {
      label: "Review Order",
      route: "/review",
      icon: <AssignmentIcon sx={{ color: white }} />,
    },
    {type:"spacer"},
    ...(isRestricted == 0
      ? [{
      label: "File Transfer",
      route: "/filetransfer",
      icon: <DriveFileMoveIcon sx={{ color: white }} />,
    },]
      : []),
    ...(isRestricted == 0
      ? [ {
      label: "Functional Admin",
      route: "/functionaladmin",
      icon: <WorkOutlineIcon sx={{ color: white }} />,
    },]
      : []),
    ...(isAdmin
      ? [{
          label: "Central Admin",
          route: "/admin",
          icon: <AdminPanelSettingsOutlinedIcon sx={{ color: white }} />,
        },]
      : []),
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const currLocation = location.pathname.split("/")[1];
  const isFileTransferPage = currLocation==='filetransfer';
  const isAnalyze= currLocation==='analyze';

  useEffect(()=>{
    // debugger;
    const currentIndex=menuSelection[currLocation];
    setSelectedIndex(currentIndex);
    if(!isAnalyze)
    dispatch(setState("isGCountryChangedAnalyze", false));
  },[currLocation]);

  const CustomNavLink = ({ route, label, icon }) => {
    let resolved = useResolvedPath(route);
    let match = useMatch({ path: resolved.pathname, end: true });

    // useEffect(() => {
    //   setSelectedIndex(menuSelection[currLocation]);
    // }, []);

    return (
      <Tooltip
        title={<span style={{ fontSize: 17 }}>{label}</span>}
        placement="right-start"
      >
        {/* <Tooltip
					title={<span style={{ fontSize: 17 }}>{label}</span>}
					placement="right-start"
				> */}
        <ListItemButton
          className="nav-menu-item-wrapper"
          component={Link}
          to={route}
          selected={match ? true : false}
        >
          <ListItemIcon className="nav-menu-item-icon">{icon}</ListItemIcon>
          <ListItemText
            className="nav-menu-item-text"
            primary={label}
            style={{ opacity: open ? 1 : 0 }}
          />
        </ListItemButton>
        {/* </Tooltip> */}
      </Tooltip>
    );
  };

  //const dispatch = useDispatch();
  const handleDrawerOpen = () => {
    setOpen(!open);
    //dispatch(setGlobalState("drawerOpen", !open));
    //dispatch(setState("drawerOpen", !open));
  };

  const handleCountryChange = (e) => {
    // debugger;
    setSelectedCountryData(e.target.value);
    const countryName = e.target.value;

    if( countryName === "Select") {
      dispatch(setState("globalSelectedCountryName", ""));
      dispatch(setState("globalSelectedCountryID", null));
      setCountry(e.target.value);
      return;
    }

    const countryID = countriesList.find(
      (f) => f.country.countryName === countryName
    ).country.countryID;
    dispatch(setState("globalSelectedCountryName", countryName));
    dispatch(setState("globalSelectedCountryID", countryID));
    if(isAnalyze){
      dispatch(setState("isGCountryChangedAnalyze", true));
    }
    else{
      dispatch(setState("isGCountryChangedAnalyze", false));
    }
    setCountry(e.target.value);
    console.log(currLocation);
  };

  const handleListItemClick = (value, index) => {
    setSelectedIndex(index);
  };

  const handlePopperClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopperClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(setState("isLoggedIn", false));
    dispatch(setState("globalSelectedCountryName", ""));
    dispatch(setState("globalSelectedCountryID", ""));    
    localStorage.removeItem("data");
    localStorage.clear();
    sessionStorage.clear();
    navigate("/mslogin");
  };

  const handleLogoutForTimeOut = () => {
    dispatch(setState("isLoggedIn", false));
    // dispatch(setState("globalSelectedCountryName", ""));
    // dispatch(setState("globalSelectedCountryID", ""));       
    localStorage.removeItem("data");
    localStorage.clear();
    sessionStorage.clear();
  };
  // useIdleTimeout(()=>{
  //   handleLogout();
  // },30*60*1000)

  useIdleTimeout(()=>{
    handleLogoutForTimeOut();
  },30*60*1000)

  useTokenValidation();

  useEffect(() => {
    // debugger;
    let lastActive = parseInt(localStorage.getItem("lastActiveTime"), 10);
    if (!lastActive) {
      localStorage.setItem("lastActiveTime", Date.now().toString());
      lastActive= parseInt(localStorage.getItem("lastActiveTime"), 10);
    }
    const THIRTY_MINUTES = 30 * 60 * 1000;
  
    if (!lastActive || Date.now() - lastActive > THIRTY_MINUTES) {
      handleLogoutForTimeOut();
    }
  }, []);  


  const popperOpen = Boolean(anchorEl);
  const popperId = popperOpen ? "simple-popover" : undefined;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <ThemeProvider theme={appBarTheme}>
        <AppBar position="fixed" open={open}>
          <Toolbar>
            {/* <img height="40px" src={logo} alt="SIMS" /> */}
            <Box sx={{ml:1}}>
            <img src={logo} alt="SiMS" width={110} sx={{ mr: 2 ,}} />
            </Box>
            {!isFileTransferPage &&(
            <Grid item sm={4} md={2} lg={1.8}>
					<FormControl>
						<InputLabel>Country</InputLabel>
						<Select
							value={selectedCountryData}
							label="Country"
							sx={{
								// height: selectHeight,
								// width: selectWidth,
								color: "black.main",
								mt: 1,
							}}
							onChange={handleCountryChange}
						>
              <MenuItem value={"Select"}>{"Select"}</MenuItem>
							{countriesList?.map((country, index) => {
								return (
									<MenuItem key={index} value={country.country.countryName}>
										{country.country.countryName}
									</MenuItem>
								);
							})}
						</Select>
					</FormControl>
				</Grid>
            )}
           <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginLeft: '0px',
              mr:4
            }}
          >
            <Avatar variant="rounded" sx={{mr:1}}>
              <AccountCircleIcon
                sx={{ cursor: "pointer"}}
                onClick={handlePopperClick}
              />
            </Avatar>
            <Box sx={{ ml: 0 }}>
              <Grid container columns={6} spacing={1} justifyContent="flex-end"> 
                <Grid item sm={5}> 
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "#000000",
                      fontFamily: montserratFont,
                      fontWeight: "bold"
                    }}
                  >
                    {userFirstName}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 12,
                      color: "darkred.light",
                      fontFamily: montserratFont,
                      fontWeight: "bold"
                    }}
                  >
                    {userEmail}
                  </Typography>
                </Grid>
                <Grid item sm={1} container justifyContent="center" alignItems="center" sx={{ml:2}}> 
                  <LogoutIcon
                    sx={{
                      fontSize: "1.8rem", 
                      color: "darkred.light", 
                      fontWeight: "bold",
                      cursor: "pointer",
                      ml:1
                    }}
                    onClick={handleLogout}
                  />
                </Grid>
              </Grid>
            </Box>
          </Box>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
      <Drawer variant="permanent" open={open}>
        <DrawerHeader sx={{ ml: 3 }}>
          {open ? <img src={takedaLogo} alt="Takeda-Logo" width={150} style={{marginTop:"35px"}} /> : ""}
        </DrawerHeader>
        <ThemeProvider theme={appBarTheme}>
          <List disableadding sx={{ mt: 6,position:'relative',height:'100%' }}>
            {navigationTop.map((item, index) =>
            item.type==="spacer" ? (<Divider sx={{my:1,backgroundColor:"rgba(255,255,255,0.2)"}}/>) :
            (
              <ListItem
                key={item.label}
                variant="contained"
                button
                disablePadding
                style={{ display: "block" }}
                selected={selectedIndex === menuSelection[item.route.split("/")[1]]}
                onClick={() => handleListItemClick(menuSelection[item.route.split("/")[1]])}
              >
                <CustomNavLink
                  route={item.route}
                  label={item.label}
                  icon={item.icon}
                />
              </ListItem>
            ))}

            <ListItem
              button
              variant="contained"
              key="openMenu"
              disablePadding
              style={{ display: "block", marginTop: 1 }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: "normal",
                  pl: 2,
                }}
                onClick={handleDrawerOpen}
              >
                <ListItemIcon sx={{ minWidth: 0, justifyContent: "normal" }}>
                  <MenuIcon
                    sx={{
                      color: white,
                      ...(open && {}),
                    }}
                  />
                </ListItemIcon>
              </ListItemButton>
            </ListItem>
          </List>
        </ThemeProvider>
      </Drawer>
      <Main open={open} sx={{ pl: 0, ml: 2, width: "95%" }}>
        <DrawerHeader />
        <Outlet />
      </Main>
    </Box>
  );
}
